<script setup lang="ts">
import type { PresentableAircraft } from "@ca/types/aircraft";

import { computed } from "vue";

import AircraftImg from "./AircraftImg.vue";

const props = withDefaults(defineProps<{
	aircraft: PresentableAircraft
	size?: "xs" | "sm" | "lg"
}>(), {
	size: "sm",
});

const label = computed(() => {
	const parts = [props.aircraft.make, props.aircraft.model];
	if (props.aircraft.year) {
		parts.unshift(props.aircraft.year);
	}
	return parts.join(" ");
});

const avatarSize = computed(() => {
	if (props.size === "xs") {
		return "sm";
	}
	return props.size === "lg" ? "3xl" : "md";
});

</script>

<template>
  <div class="flex items-center gap-2">
    <AircraftImg
      :make="aircraft.make"
      :size="avatarSize"
    />

    <div>
      <router-link
        :to="`/aircraft/${aircraft.tailNumber}`"
        class="leading-none font-cta text-brand-500"
        :class="size === 'lg' ? 'text-4xl font-bold' : 'text-lg'"
      >
        {{ aircraft.tailNumber }}
      </router-link>
      <div
        :title="label"
        :class="size === 'lg' ? 'text-lg' : 'text-xs'"
        class="text-gray-500 font-sans line-clamp-1 leading-none"
      >
        {{ label }}
      </div>
    </div>
  </div>
</template>